// extracted by mini-css-extract-plugin
module.exports = {"img":"_1FR26","annotation":"_14dwp","magnifier":"_3y-sz"};